import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { createCommunityCategorie, editCommunityCategory,
seeListCommunityCategories, deleteCommunityCategorie } from '../../actions/categoriesActions'
import { Translate } from '../../../language';
import inMemoryJWT from '../../../auth/inMemoryJwt';

const CommunityCategorieAdmin = ({ history, createCommunityCategorie, listOfCommunitiesCategory, isLoadingListCommunityCategories, editCommunityCategory, seeListCommunityCategories, deleteCommunityCategorie }) => {

    useEffect(() => {
        if(!(inMemoryJWT.getToken())){
            inMemoryJWT.getRefreshedToken()
        }

        inMemoryJWT.waitForTokenRefresh().then(() => {
            seeListCommunityCategories()
        })
        
    },[])
    const [isEdit, setIsEdit] = useState(false)
    const [idEdit, setIdEdit] = useState('')
    const [indexEdit, setIndexEdit] = useState('')
    const [nameCategorie, setNameCategorie] = useState('')
    const [description, setDescription] = useState('')
    const [isValidate, setValidate] = useState(false)
    const [error, setError] = useState({})

    const isFocused = (e) => {
        const { name } = e.target;
        setError(prevError => ({
            ...prevError,
            [name]: ''
        }));
    }


    const isEmpty = (e) => {
        if (nameCategorie !== '' && description !== '') {
            setValidate(true)
        }
        const { name, placeholder, value } = e.target;
        if (value.length === 0) {
            setValidate(false)
            setError(prevError => ({
                ...prevError,
                [name]: Translate('missingField', 'es') + placeholder
            }));
        }
        if (value.length !== 0) {

            setError(prevError => ({
                ...prevError,
                [name]: ''
            }));
        }

    }

    console.log()
    return (
        <div className="container-mark-type-admin">
            <div className="new-edit-type-mark-container-admin">
                <div className='title-admin'>{`${isEdit ? 'Editar' : 'Nueva'} categoria para comunidades`}</div>
                <div className="container-inputs-new-mark">
                    <div className="text-input-admin">
                        {'Nombre:'}
                    </div>
                    <input
                        name='nameCategorie'
                        className='inputs-admin'
                        value={nameCategorie}
                        onChange={(e) => {
                            setNameCategorie(e.target.value.trimStart())
                            if (nameCategorie !== '' && description !== '') {
                                setValidate(true)
                            }
                        }}
                        onBlur={e => isEmpty(e)}
                        onFocus={e => isFocused(e)}
                        onKeyUp={e => isEmpty(e)}
                    />
                    <div className="text-error text-error-admin">{error.name}</div>
                    <div className="text-input-admin">
                        {'Descripción:'}
                    </div>
                    <input
                        name='description'
                        className='inputs-admin'
                        value={description}
                        onChange={(e) => {
                            setDescription(e.target.value.trimStart())
                            if (description !== '' && nameCategorie !== '') {
                                setValidate(true)
                            }
                        }}
                        onBlur={e => isEmpty(e)}
                        onFocus={e => isFocused(e)}
                        onKeyUp={e => isEmpty(e)}
                        autoComplete='off'
                    />
                    <div className="text-error text-error-admin">{error.description}</div>

                    {isEdit ?
                        <div className="content-buttom-create-admin">
                            <button className={`btns-admin btn-create-edit btns-admin-inactive`} onClick={() => {
                                setNameCategorie('')
                                setDescription('')
                                setIdEdit('')
                                setIndexEdit('')
                                setIsEdit(false)
                            }}>
                                {Translate('cancel', 'es')}
                            </button>
                            <div className="ml-1 mr-1"></div>
                            <button disabled={isValidate ? '' : 'disabled'}
                                className={`btns-admin btn-create-edit ${isValidate ? '' : 'btns-admin-inactive'}`} onClick={() => {
                                    editCommunityCategory({ name: nameCategorie.trim(), description: description.trim(), id: idEdit }, history, indexEdit)
                                    setNameCategorie('')
                                    setDescription('')
                                    setIdEdit('')
                                    setIndexEdit('')
                                    setIsEdit(false)
                                }}>
                                {Translate('edit', 'es')}
                            </button>
                        </div>

                        :
                        <div className="content-buttom-create-admin">
                            <button disabled={isValidate ? '' : 'disabled'}
                                className={`btns-admin btn-create-edit ${isValidate ? '' : 'btns-admin-inactive'}`} onClick={() => { createCommunityCategorie({ name: nameCategorie.trim(), description: description.trim() }, history) }}>
                                {Translate('create', 'es')}
                            </button>
                        </div>

                    }
                </div>
            </div>
            <div className="see-all-mark-type-admin">
                <div className='title-admin-list'>Categorias existentes</div>
                <div className='wrapper-2 column-gap row-gap mt-3'>
                    {isLoadingListCommunityCategories ? <div>Cargando...</div> :
                        listOfCommunitiesCategory.map((categorie, index) => (
                            <div key={categorie._id} className="card-admin">
                                <div className="tittle-card-admin">{categorie.name}</div>
                                <div className="text-content-card">{categorie.description}</div>
                                <div className="column centerContent">
                                    <div className="btns-admin ml-1 mr-1" onClick={() => {
                                        setNameCategorie(categorie.name)
                                        setDescription(categorie.description)
                                        setIdEdit(categorie._id)
                                        setIndexEdit(index)
                                        setIsEdit(true)
                                    }}>Editar</div>
                                    <div className="btns-admin btns-admin-red" onClick={() => { deleteCommunityCategorie(categorie._id, index) }}>Eliminar</div>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        isLoadingListCommunityCategories: state.categoriesAdmin.isLoadingListCommunityCategories,
        listOfCommunitiesCategory: state.categoriesAdmin.listOfCommunitiesCategory
    }
}


export default connect(mapStateToProps, { createCommunityCategorie, editCommunityCategory, seeListCommunityCategories, deleteCommunityCategorie })(CommunityCategorieAdmin)